import { IAppState } from 'config/redux/reducers';
import { useSelector } from 'react-redux';

const useApigeeLabels = () => {
  const { labels } = useSelector((state: IAppState) => ({
    labels: state.apigeeLabels.data,
  }));

  return labels;
};

export default useApigeeLabels;
